import { useNavigate } from "react-router-dom";

import AuthRoutes from "Routes/Components/Auth";

import CaptchaWidget from "Components/Common/CaptchaWidget";
import Button from "Components/Global/Buttons";
import Input from "Components/Global/Form/Input";
import TypographyHead from "Components/Global/Typography/Head";

import * as S from "./styles";

const SendEmail = ({
  loading,
  login,
  setLogin,
  getVerificationCode,
  sentEmail,
  setReCaptchaToken,
  captchaRef,
}) => {
  const navigate = useNavigate();

  return (
    <S.Wrapper>
      <S.Row>
        <TypographyHead
          dark
          title="Nova senha"
          description="Digite seu login para receber um e-mail com as instruções para redefinir sua senha."
        />
      </S.Row>
      <S.Form>
        <label htmlFor="email" style={{ color: "black", fontWeight: 500 }}>
          E-mail
        </label>
        <Input
          placeholder="Digite seu login cadastrado"
          type="email"
          name="email"
          id="email"
          required
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          disabled={loading}
        />
        <CaptchaWidget ref={captchaRef} onSuccess={setReCaptchaToken} />
        {sentEmail === "success" ? (
          <S.SuccessMessage>
            E-mail enviado com sucesso, verifique sua caixa de entrada!
          </S.SuccessMessage>
        ) : null}
        {sentEmail === "error" ? (
          <S.ErrorMessage>
            Houve um erro ao enviar o e-mail, tente novamente!
          </S.ErrorMessage>
        ) : null}
      </S.Form>

      <S.ButtonsWrapper>
        <Button
          type="submit"
          text="Enviar"
          onClick={() => {
            getVerificationCode();
          }}
          disabled={loading}
        />
        <Button
          type="button"
          outline
          text="Voltar"
          onClick={() => navigate(AuthRoutes.Dashboard.path)}
          icon={{
            name: "ChevronLeft",
            position: "left",
          }}
          disabled={loading}
          style={{ color: "black" }}
        />
      </S.ButtonsWrapper>
    </S.Wrapper>
  );
};

export default SendEmail;
